<script>
import { SiteSettings } from '@/api/'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  components: {},
  mixins: [FormMixin],
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.service.get().then(response => {
        this.form = response.data
        this.prepareFormCopyToPreventChangesLost()
      })
    },
    onSubmit() {
      this.loading = true
      const service = this.service.update(this.form)
      service.then(this.successHandler).catch(this.errorHandler)
    },
    getFields() {
      return [
        new fields.Input({
          label: 'Link do facebooka',
          modelPath: [this, 'form', 'facebook_url']
        })
      ]
    }
  },
  computed: {
    service() {
      return SiteSettings
    }
  }
}
</script>
